import { POSTFORM, POST, GET } from '@/utils/request'
import Api from './url'
export const getActivityDetail = async (params: object) => {
  return await GET({
    url: Api.getActivityDetail,
    params,
    showError: false
  })
}
